import { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';

import CustomCard from '../../components/shared/CustomCard';
import DashboardTable from '../../components/shared/Table';
import TableHeading from '../../components/shared/TableHeading';
import Pagination from '../../components/shared/TablePagination';
import { getStateTableData, getStatsData, getPlacementData, getTableCsv, getPlacementDataCSV } from '../../services/adminService/adminService';
import ViewToggleDropdown from '../../components/shared/ViewToggleDropdown';
import { BiDownload } from 'react-icons/bi';
import Swal from 'sweetalert2';
import Skeleton from 'react-loading-skeleton';

const PlacementOverview = ({ selectedRange, showImage, selectedCampagins }) => {
    const userData = JSON.parse(localStorage.getItem('user'));

    const [companyId, setCompanyId] = useState(localStorage.getItem('selectedCompany'));


    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const [tableLoading, setTableLoading] = useState(true);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    // const[tableData,setTableDate]

    const [stats, setStats] = useState(null);
    const [ftdShow, setFtdSow] = useState();
    const [tableData, setTableData] = useState({ columns: [], rows: [], pagination: {} });
    const [totalPages, setTotalPages] = useState(1);
    const [activeView, setActiveView] = useState('monthly');
    const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("user")) || {});



    const dashboardCards = stats?.dynamicResults
        ? Object.entries(stats.dynamicResults)
            .filter(([label]) => label !== "Forecasted Budget")
            .map(([label, value]) => ({
                label: label,
                value: label === "Budget" || label === "Actual Budget"
                    ? `${new Intl.NumberFormat('fr-FR').format(value)} ${stats?.currency || ''}`
                    : `${new Intl.NumberFormat('fr-FR').format(value)}`,
            }))
        : [];
    const getStats = async (formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setLoading(true);
            const response = await getStatsData(formattedStartDate, formattedEndDate, companyId, selectedCampagins);
            setStats(response?.data?.data);
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }


    const getData = async (formattedStartDate, formattedEndDate, selectedCampagins, page = 1, view = 'monthly') => {
        try {
            setTableLoading(true);
            const response = await getPlacementData(companyId, formattedStartDate, formattedEndDate, page, 10, view, selectedCampagins);

            console.log("Original API Response:", response.data);

            // Handle the API response structure
            if (response.data && response.data.success) {
                const columns = response.data.columns || [];
                const rows = response.data.rows || [];

                // Transform rows from array of objects to array of arrays
                const transformedRows = rows.map(row => {
                    return columns.map(column => {
                        const value = row[column];
                        // Handle null/undefined values
                        if (value === null || value === undefined) {
                            return '';
                        }
                        // Handle iconUrl specially for image display
                        if (column === 'iconUrl' && value) {
                            return value;
                        }
                        return value;
                    });
                });

                console.log("Transformed data for table:", {
                    columns: columns,
                    rows: transformedRows,
                    pagination: response.data.pagination
                });

                setTableData({
                    columns: columns,
                    rows: transformedRows,
                    pagination: response.data.pagination || {}
                });
                setTotalPages(response.data.pagination?.totalPages || 1);
                setCurrentPage(response.data.pagination?.currentPage || 1);
            } else {
                setTableData({ columns: [], rows: [], pagination: {} });
            }
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setTableData({ columns: [], rows: [], pagination: {} });
        } finally {
            setTableLoading(false);
        }
    }





    console.log("Placement Data", tableData);
    console.log("Transformed rows for table:", tableData.rows);
    console.log("Table columns:", tableData.columns);
    console.log("Pagination state:", {
        currentPage,
        totalPages,
        pagination: tableData.pagination
    });

    useEffect(() => {

        const handleCompanyChange = () => {
            setCompanyId(localStorage.getItem('selectedCompany'));
        };
        window.addEventListener('user-update', handleCompanyChange);

        return () => {
            window.removeEventListener('user-update', handleCompanyChange);
        };
    }, [companyId]);
    useEffect(() => {
        if (selectedRange && selectedRange?.length === 2) {
            setCurrentPage(1);
            const [startDate, endDate] = selectedRange;
            const formatLocalDate = (date) => {
                return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
            };
            const formattedStartDate = formatLocalDate(startDate);
            const formattedEndDate = formatLocalDate(endDate);
            setStartDate(formattedStartDate);
            setEndDate(formattedEndDate);

            getStats(formattedStartDate, formattedEndDate, selectedCampagins);

        }
    }, [selectedRange, companyId, selectedCampagins]);

    useEffect(() => {
        if (selectedRange && selectedRange?.length === 2) {
            const [startDate, endDate] = selectedRange;
            const formatLocalDate = (date) => {
                return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
            };
            const formattedStartDate = formatLocalDate(startDate);
            const formattedEndDate = formatLocalDate(endDate);
            setStartDate(formattedStartDate);
            setEndDate(formattedEndDate);
            getData(formattedStartDate, formattedEndDate, selectedCampagins, currentPage, activeView);
        }
    }, [selectedRange, currentPage, companyId, selectedCampagins, activeView]);
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleViewToggle = (view) => {
        setActiveView(view);
        setCurrentPage(1); // Reset to first page when changing view
    };

    const handleDownloadCsv = async () => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to download the Table Data?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1cc76d",
            cancelButtonColor: "#6C757D",
            confirmButtonText: "Yes, download it!",
            cancelButtonText: "No, cancel",
            allowOutsideClick: false,
            preConfirm: () => {
                Swal.showLoading();
                return new Promise(async (resolve, reject) => {
                    try {
                        // const response = await getTableCsv(startDate, endDate, companyId, selectedCampagins);
                        const response = await getPlacementDataCSV(companyId, startDate, endDate, activeView, selectedCampagins);

                        const fileUrl = response?.data?.fileUrl;

                        if (fileUrl) {
                            const link = document.createElement("a");
                            link.href = fileUrl;
                            link.download = fileUrl.split("/").pop();
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            resolve();
                        } else {
                            reject("File URL not found in response");
                        }
                    } catch (error) {
                        console.error("Error downloading file:", error);
                        reject("Error downloading the file. Please try again.");
                    }
                });
            },
        })
            .then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "Downloaded!",
                        text: "The XLSX file has been downloaded successfully.",
                        icon: "success",
                        confirmButtonColor: "#28a745",
                    });
                }
            })
            .catch((error) => {
                Swal.fire({
                    title: "Error!",
                    text: error || "An unexpected error occurred during the download.",
                    icon: "error",
                    confirmButtonColor: "#dc3545",
                });
            });
    };

    return (

        <Container className={`mb-5 ${showImage ? 'px-5' : 'dashboard-page'}`} fluid>
            <CustomCard data={dashboardCards} stats={stats} loading={loading} />
            <Row>
                <Col className={`${showImage ? 'pb-5' : 'max-width-table'}`}>
                    <div className={`p-4 bg-white my-md-4 mt-4 rounded-4  ${showImage ? '' : ''}`} style={{ minHeight: '63.6vh' }}>
                        <div className='d-flex justify-content-between align-items-center mb-md-4'>
                            <TableHeading heading={"Placement Overview"} />
                            <div className='d-none d-lg-flex align-items-center'>
                                {/* {tableData.rows && tableData.rows?.length > 0 && */}
                                <ViewToggleDropdown
                                    activeView={activeView}
                                    onToggle={handleViewToggle}
                                    loading={tableLoading}
                                />
                                {/* } */}
                                {user.showExportTable && activeView === 'monthly' && tableData.rows && tableData.rows?.length > 0 && (
                                    <Button
                                        className="btn-sm d-flex align-items-center gap-1 border-0 ms-3"
                                        style={{ backgroundColor: 'transparent', color: 'var(--color2)' }}
                                        onClick={handleDownloadCsv}
                                    >
                                        <BiDownload color="var(--color2)" size={25} />
                                    </Button>
                                )}
                                <div className='ms-4'>
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onNext={handleNext}
                                        onPrevious={handlePrevious}
                                        loading={tableLoading}
                                    />
                                </div>
                            </div>
                            {user.showExportTable && activeView === 'monthly' && tableData.rows && tableData.rows?.length > 0 && (
                                <Button
                                    className="btn-sm d-lg-none d-flex align-items-center gap-1 border-0"
                                    style={{ backgroundColor: 'transparent', color: 'var( --color2)' }}
                                    onClick={handleDownloadCsv}
                                >
                                    <BiDownload color="var(--color2)" size={25} />
                                </Button>
                            )}
                        </div>
                        <div className='d-lg-none d-flex justify-content-end my-3'>
                            <ViewToggleDropdown
                                activeView={activeView}
                                onToggle={handleViewToggle}
                                loading={tableLoading}
                            />

                        </div>
                        <div className="mt-4">
                            <DashboardTable
                                tableBody={tableData.rows || []}
                                tableHeadings={tableData.columns || []}
                                loading={tableLoading}
                                sticky={false}
                            />
                        </div>
                        <div className='d-lg-none d-block'>
                            <div className='d-flex justify-content-between align-items-center mb-3'>
                                {activeView === 'monthly' && tableData.rows && tableData.rows?.length > 0 && (
                                    <Button
                                        className="btn-sm d-flex align-items-center gap-1 border-0"
                                        style={{ backgroundColor: 'transparent', color: 'var(--color2)' }}
                                        onClick={handleDownloadCsv}
                                    >
                                        <BiDownload color="var(--color2)" size={25} />
                                    </Button>
                                )}
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onNext={handleNext}
                                    onPrevious={handlePrevious}
                                    loading={tableLoading}
                                />
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container >

    );
};

export default PlacementOverview;
